<template>
    <div
        class="option-box"
        :class="selected === true ? 'selected-option' : 'unselected-option'"
        :style="styleObj"
    >
        <span>{{label}}</span>
    </div>
</template>

<script setup>

import {computed, toRef, ref} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";

const props = defineProps(["obj", "selected"])

const userInfoRef = toRef(useUserinfo())

const styleObj = computed(() => {
    let obj = {}

    if (props.obj.disabled === true){
        obj = {
            "cursor": "not-allowed",
            "transition": "none",
            "color": "#C0C4CC"
        }
    }

    return obj
})

const label = computed(() => {
    let text = props.obj.typename2

    if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(text)){
        text = props.obj.typename

        if (myUtil.isEmpty(text)){
            text = props.obj.typename2
        }
    }

    return text
})

</script>

<style scoped>

.option-box {
    padding-right: 8px;
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    transition: 0.5s all ease;
}

.option-box:hover {
    color: #F56C6C;
}

.unselected-option {
    color: #303133;
}

.selected-option {
    color: #F56C6C;
}

</style>